import { GetTermSectionsCommand } from './get_term_sections_command';
import { GetTermCoursesCommand } from './get_term_courses_command';
import { LoadAllRegistrationAttributesForSectionsCommand } from '../../../registration_attributes/commands/load_all_registration_attributes_for_sections_command';
import { IDefineCommand, ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IPlannedCourse } from '../../../interfaces/scheduler_interfaces';
import { UpdateCalendarSectionTimesCommand } from '../../calendar/commands/update_calendar_section_times_command';

export type GetTermCoursesandScheduledSectionsCommand = (termId: IPlannedCourse['term']) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'getTermCoursesandScheduledSectionsCommand',
    (
      getTermCoursesCommand: GetTermCoursesCommand,
      defineCommandORM: IDefineCommand,
      getTermSectionsCommand: GetTermSectionsCommand,
      updateCalendarSectionTimesCommand: UpdateCalendarSectionTimesCommand,
      loadAllRegistrationAttributesForSectionsCommand: LoadAllRegistrationAttributesForSectionsCommand,
      log: any
    ): ICommand => {
      return defineCommandORM(
        'getTermCoursesandScheduledSectionsCommand',
        (deferred, termId: IPlannedCourse['term']) => {
          getTermCoursesCommand(termId)
            .then(() => getTermSectionsCommand(termId))
            .then(() => loadAllRegistrationAttributesForSectionsCommand())
            .then(() => updateCalendarSectionTimesCommand())
            .then(deferred.resolve)
            .catch((e) => {
              log.issue('Failed to get courses or sections for this term');
              deferred.reject(e);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/term_courses/commands/get_term_courses_and_scheduled_sections_command.ts